module.exports = __webpack_public_path__ + "img/8d5658e.png";